import sortBy from 'lodash/sortBy';

interface OrderedBankAccount {
  id: string;
  createdAt?: string | null;
}

/** Oldest account first, so adding one or refetching the list never moves the others. */
export const sortBankAccountsByCreation = <T extends OrderedBankAccount>(bankAccounts: T[]): T[] =>
  sortBy(bankAccounts, [({ createdAt }) => createdAt ?? '', 'id']);
